import { Box, Typography } from "@mui/material";
import { useTheme } from "../context/ThemeContext";
import AttachedFileChip from "./AttachedFileChip";
import { getFileTypeFromFileName } from "../utils/fileTypeUtils";

export default function UserMessageComponent({ message }) {
  const { isDark } = useTheme();
  const attachedFiles = message.attached_files || [];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        gap: "8px",
        mt: 1.5,
      }}
    >
      {attachedFiles.length > 0 && (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          {attachedFiles.map(f => (
            <AttachedFileChip
              key={f.file_id}
              file_id={f.file_id}
              file_name={f.file_name}
              file_type={f.file_type || getFileTypeFromFileName(f.file_name)}
            />
          ))}
        </Box>
      )}
      {message.value && (
        <Typography
          sx={{
            fontSize: "14px",
            lineHeight: "20px",
            color: isDark ? "#F1F4F8" : "#434950",
            fontFamily: "Inter",
            fontWeight: "400",
            letterSpacing: "0.035px",
            background: isDark ? "#6A7079" : "#FFFFFF",
            border: "1px solid",
            borderColor: isDark ? "#404549" : "#E2E8F0",
            borderRadius: "16px 16px 6px 16px",
            boxShadow: "0px 8px 20px 0px rgba(0,0,0,0.04)",
            p: "12px 16px",
            width: "fit-content",
            maxWidth: "calc(100% - 24px)",
            wordWrap: "break-word",
          }}
        >
          {message.value}
        </Typography>
      )}
    </Box>
  );
}
